export const STARTED = "STARTED";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";


// WEBPACK FOOTER //
// ./src/components/dashboard/synchronization/enums/syncStatusTypes.js